import React, { useEffect, useState, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';
import { Mail, Phone } from 'lucide-react';

export default function AdminContacts() {
  const { apiClient } = useAuth();
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchContacts = useCallback(async () => {
    try { const { data } = await apiClient.get('/api/admin/contacts'); setContacts(data); }
    catch { toast.error('Failed to load'); }
    finally { setLoading(false); }
  }, [apiClient]);

  useEffect(() => { fetchContacts(); }, [fetchContacts]);

  return (
    <div data-testid="admin-contacts-page">
      <div className="mb-8">
        <h1 className="text-2xl font-heading font-bold text-white">Contact Inquiries</h1>
        <p className="text-white/50 text-sm">{contacts.length} messages received</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-white/40" /></div>
      ) : contacts.length === 0 ? (
        <div className="text-center py-16 text-white/40">No contact inquiries yet</div>
      ) : (
        <div className="space-y-4">
          {contacts.map((c) => (
            <div key={c.id} className="rounded-2xl border border-white/8 bg-white/[0.03] p-5" data-testid={`admin-contact-${c.id}`}>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-3">
                <div>
                  <h3 className="text-white font-bold text-sm">{c.name}</h3>
                  <div className="flex gap-4 mt-1">
                    <span className="flex items-center gap-1 text-white/40 text-xs"><Mail size={12} /> {c.email}</span>
                    {c.phone && <span className="flex items-center gap-1 text-white/40 text-xs"><Phone size={12} /> {c.phone}</span>}
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-orange-500/15 text-orange-300 text-xs font-bold">{c.subject}</span>
                  <span className="text-white/30 text-xs">{new Date(c.created_at).toLocaleDateString()}</span>
                </div>
              </div>
              <p className="text-white/60 text-sm leading-relaxed">{c.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
